import { useContext } from 'react';

import { format } from 'date-fns';

import { FLIGHT_TYPE, TRANSFER_TYPE } from 'components/Pages/Admin/GuestPortal/Flights/constants';
import { FlightsContext } from 'components/Pages/Admin/GuestPortal/Flights/context';
import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { showSnackbar } from 'hooks/useSnackbar';
import { getHoursAndMinutes12, getHoursAndMinutes24 } from 'utils/date';

import { getDateString } from './utils';

export function useForms(props) {
  const { itemIndex } = props;
  const {
    handleItemChange,
    handleSaveData,
    closeModal,
    handleCheckLastItem,
    needCheckEditedItem,
    handleItemEdit,
    getCurrentItem,
    dateFormat,
  } = useContext(FlightsContext);

  const handleSubmitFlight = async (values) => {
    try {
      const { departureDate, departureTime, arrivalDate, arrivalTime, ...rest } = values;
      const departureTimeFormat = getDateString({ date: departureDate, time: departureTime });
      const arrivalTimeFormat = getDateString({ date: arrivalDate, time: arrivalTime });

      const data = {
        departureTime: departureTimeFormat,
        arrivalTime: arrivalTimeFormat,
        fromFsService: false,
        type: FLIGHT_TYPE,
        ...rest,
        departureTimeEmpty: !departureTime,
        arrivalTimeEmpty: !arrivalTime,
      };
      if (data?.id) {
        await handleItemEdit(data);
        needCheckEditedItem(data.id);
      } else {
        await handleSaveData({ itemIndex, newItem: [data] });
        handleCheckLastItem();
      }

      closeModal();
    } catch (err) {
      showSnackbar({ text: 'Oops…', type: SNACKBAR_SKIN.ERROR });
    }
  };

  const handleSubmitTransfer = async (values) => {
    try {
      const { departureDate, departureTime, arrivalDate, arrivalTime, ...rest } = values;
      const departureTimeFormat = getDateString({ date: departureDate, time: departureTime });
      const arrivalTimeFormat = getDateString({ date: arrivalDate, time: arrivalTime });

      const data = {
        departureTime: departureTimeFormat,
        arrivalTime: arrivalTimeFormat,
        type: TRANSFER_TYPE,
        ...rest,
        departureTimeEmpty: !departureTime,
        arrivalTimeEmpty: !arrivalTime,
      };
      if (data?.id) {
        await handleItemEdit(data);
        needCheckEditedItem(data.id);
      } else {
        await handleSaveData({ itemIndex, newItem: [data] });
        handleCheckLastItem();
      }

      closeModal();
    } catch (err) {
      showSnackbar({ text: 'Oops…', type: SNACKBAR_SKIN.ERROR });
    }
  };

  const getManuallyInitialValues = (item) => {
    // const showDepartureTime = showTimeString(new Date(item?.departureTime));
    // const showArrivalTime = showTimeString(new Date(item?.arrivalTime));
    const departureTimeFromTable = getCurrentItem(itemIndex)?.departureTime;
    const initialValues = item?.id
      ? {
          ...item,
          departureDate: format(new Date(item.departureTime), 'MM/dd/yyyy'),
          departureTime: !item?.departureTimeEmpty
            ? `${getHoursAndMinutes12(new Date(item.departureTime))} (${getHoursAndMinutes24(
                new Date(item.departureTime),
              )})`
            : undefined,
          arrivalDate: format(new Date(item.arrivalTime), 'MM/dd/yyyy'),
          arrivalTime: !item?.arrivalTimeEmpty
            ? `${getHoursAndMinutes12(new Date(item.arrivalTime))} (${getHoursAndMinutes24(
                new Date(item.arrivalTime),
              )})`
            : undefined,
        }
      : {
          departureDate: departureTimeFromTable && format(new Date(departureTimeFromTable), 'MM/dd/yyyy'),
        };
    return initialValues;
  };

  return {
    dateFormat,
    handleItemChange,
    handleSubmitFlight,
    handleSubmitTransfer,
    getManuallyInitialValues,
  };
}
